import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@material-ui/core";
import CountTextField from "@saleor/components/CountTextField";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React, { useEffect, useState } from "react";

interface ModalNoteProps {
  initialNote?: string;
  title?: string;
  subTitle?: string;
  open: boolean;
  onClose: () => void;
  onSubmit: (name, note) => void;
  name: string;
}

const useStyles = makeStyles(
  theme => ({
    root: {
      "& .MuiPaper-root": {
        maxWidth: 480,
        width: "100%",
        borderRadius: 12
      },
      "& .MuiDialogTitle-root": {
        paddingTop: 24
      },
      "& .MuiDialogContent-root": {
        paddingBottom: 0
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        paddingBottom: 24
      }
    },
    mainTitle: {
      color: theme.palette.grey[900],
      fontWeight: 700
    },
    subTitle: {
      color: theme.palette.info.main,
      fontWeight: 400
    },
    btnCon: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      columnGap: 24
    },
    btnAction: {
      width: "50%",
      height: 48
    }
  }),
  { name: "ModalNote" }
);

const ModalNote: React.FC<ModalNoteProps> = props => {
  const { initialNote, title, subTitle, open, onClose, onSubmit, name } = props;
  const [note, setNote] = useState<string>(initialNote ? initialNote : "");
  const classes = useStyles();
  useEffect(() => {
    setNote(initialNote);
  }, [initialNote]);

  const handleSubmit = () => {
    onSubmit(name, note);
  };

  const handleChangeNote = data => {
    setNote(data.target.value);
  };

  const handleClose = () => {
    if (initialNote !== null) {
      setNote("");
    }
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} className={classes.root}>
      {title ? (
        <DialogTitle>
          <MyTypography variant="subtitle2" className={classes.mainTitle}>
            {title}{" "}
            {subTitle ? (
              <span className={classes.subTitle}>({subTitle})</span>
            ) : (
              ""
            )}
          </MyTypography>
        </DialogTitle>
      ) : (
        ""
      )}
      <DialogContent>
        <CountTextField
          name={name}
          onChange={data => handleChangeNote(data)}
          value={note}
        />
      </DialogContent>
      <DialogActions>
        <div className={classes.btnCon}>
          <Button
            color={"secondary"}
            variant={"outlined"}
            onClick={handleClose}
            className={classes.btnAction}
          >
            ยกเลิก
          </Button>
          <Button
            color={"secondary"}
            variant={"contained"}
            onClick={handleSubmit}
            className={classes.btnAction}
          >
            บันทึก
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default ModalNote;
